// extracted by mini-css-extract-plugin
export default {"container":"AccessTab_container__KP7nJ","icon":"AccessTab_icon__onenF","wrapper":"AccessTab_wrapper__5WwHe","title":"AccessTab_title__5aqDf","button":"AccessTab_button__0FisL"};